<template>
  <el-table
      ref="multipleTableRef"
      :data="tableData"
      style="width: 100%;margin-top: 8px;height: max-content"
      :v-loading="isLoading"
      :header-cell-style="{'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}">
    >
    <el-table-column
        v-for="item in table_columns"
        :key="item.key"
        :label="item.key"
        :prop="item.value"
    >
      <template #default="{ row, column, $index }">
        <template v-if="item.value==='labelName'">
          <el-tag type="info">{{ row?.labelName }}</el-tag>
        </template>
      </template>
    </el-table-column>
    <el-table-column :label="$t('common.operate')" fixed="right" width="180">
      <template #default="{ row, column, $index }">
        <el-button type="primary" link @click="handleEdit(row)">{{ $t('common.edit') }}</el-button>
        <ConfirmDeletePopover
            :visible="row.popoverVisible"
            :width="164"
            :message="$t('confirm.to.delete.data')"
            @update:visible="(value) => (row.popoverVisible = value)"
            @confirm:delete="handleDelete(row, column, $index)"
        >
          <template #settings>
            <el-button :loading="row.isDeleteLoading" link type="danger" @click="row.popoverVisible = true;">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </ConfirmDeletePopover>
      </template>
    </el-table-column>
    <template #empty>
      <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
    </template>
  </el-table>
  <div class="pages">
    <el-button type="primary" size="small" :icon="Plus" @click="handleAddNewTag()">{{
        $t('label.btn.add')
      }}
    </el-button>
    <el-pagination
        size="small"
        v-model:current-page="pageNo"
        v-model:page-size="pageSize"
        background
        layout="total, prev, pager, next"
        v-if="total"
        :total="total"
        @current-change="handleCurrentChange"
    />
  </div>

  <add-new-tag-dialog ref="editNewTag" v-if="dialogVisible" v-model="dialogVisible"
                      @close="close" :flagType="flagType" :isEdit="isEdit"
                      :currentRow="currentRow"
                      @getList="getTableTagList"
  >
  </add-new-tag-dialog>
</template>

<script setup>
import {ElMessage, ElTable} from "element-plus";
import {ref, defineProps, defineEmits, onMounted, computed} from "vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {emptyUrl} from '@/utils/statusParams'
import AddNewTagDialog from "@/views/components/addNewTagDialog.vue";
import {useStore} from "vuex";
import {Plus} from "@element-plus/icons-vue";
import {mailCustomerLabelDelete, mailCustomerLabelList} from "@/api/customer";

const emits = defineEmits()
const store = useStore()

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false
  },
  table_columns: {
    type: Array, pe: Array,
    default: () => []
  },
  labelType: {
    type: Number,
    default: 0,
  }
})

const handleDelete = async (row) => {
  row.dialogVisible = true;
  try {
    const payload = {
      idList: [row.id],
    }
    row.isDeleteLoading = true
    const res = await mailCustomerLabelDelete(payload)
    await getTableTagList()
    row.isDeleteLoading = false
    ElMessage.success(res.message)
  } catch (e) {
    row.isDeleteLoading = false
    ElMessage.error(e.message)
  }
}

const dialogVisible = ref(false)
const currentRow = ref({})
const tableData = ref([])
const handleEdit = (row) => {
  dialogVisible.value = true;
  isEdit.value = true
  currentRow.value = row
}
const close = () => {
  dialogVisible.value = false
}

const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const teamId = computed(() => store.state.email.teamID);
const isLoading = ref(false)
const getTableTagList = async () => {
  try {
    const payload = {
      labelType: props.labelType,
      pageNo: pageNo.value,
      pageSize: pageSize.value,
      teamId: teamId.value
    }
    isLoading.value = true
    const res = await mailCustomerLabelList(payload)
    tableData.value = res.result.records;
    pageNo.value = res.result.current;
    pageSize.value = res.result.size;
    total.value = res.result.total;
    isLoading.value = false
  } catch (e) {
    isLoading.value = false
  }
}

const handleCurrentChange = async (val) => {
  pageNo.value = val;
  await getTableTagList()
}


onMounted(async () => {
  await getTableTagList()
})

const isEdit = ref(false)
const flagType = ref(0)
const handleAddNewTag = () => {
  flagType.value = props.labelType;
  dialogVisible.value = true
  isEdit.value = false;
}


</script>

<style lang="less" scoped>
:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}
</style>